import { useMemo } from 'react';
import { SWRKey, useSWRImmutable } from 'services/swr';
import { useUser } from 'services/User';

export interface LimitsStatus {
    prevention_api?: number;
    reputation_api?: number;
    sandbox_api?: number;
    threat_intel_search_api?: number;
}

export const useApikeyLimits = () => {
    const { user } = useUser();
    const apikey = user?.portal_api_key;

    const key: SWRKey = useMemo(() => (apikey ? { url: '/v4/apikey/limits/status' } : null), [apikey]);

    return useSWRImmutable<LimitsStatus>(key, { shouldRetryOnError: false });
};
